import React, { useState } from "react";
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Button, Select, MenuItem, FormControl, InputLabel, Typography
} from "@mui/material";
import { postData } from "../../BaseUrl";

const AssignSectionDialog = ({ open, onClose, student, sections, onSuccess }) => {
  const [sectionId, setSectionId] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const availableSections = sections.filter(s => s.enrolledCount < s.maxCapacity);

  const handleSubmit = async () => {
    if (!sectionId) {
      setError("Please select a section");
      return;
    }
    setLoading(true);
    setError("");
    try {
      await postData("admin/admission/sections/assign", {
        applicationId: student.id,
        sectionId: parseInt(sectionId)
      });
      const selectedSection = sections.find(s => s.id === parseInt(sectionId));
      onSuccess(`Student assigned to ${selectedSection?.displayName}`);
      setSectionId("");
    } catch (err) {
      setError(err?.message || "Assignment failed");
    }
    setLoading(false);
  };

  return (
    <Dialog open={open} onClose={() => { onClose(); setSectionId(""); setError(""); }} maxWidth="xs" fullWidth>
      <DialogTitle sx={{ fontWeight: "bold" }}>
        Assign Section
      </DialogTitle>
      <DialogContent>
        <Typography variant="body2" color="text.secondary" mb={2}>
          {student?.firstName} {student?.lastName} (Reg# {student?.registrationNumber})
        </Typography>
        <FormControl fullWidth size="small">
          <InputLabel>Select Section *</InputLabel>
          <Select value={sectionId} label="Select Section *"
            onChange={(e) => setSectionId(e.target.value)}>
            {availableSections.map(sec => (
              <MenuItem key={sec.id} value={sec.id}>
                {sec.displayName} ({sec.enrolledCount}/{sec.maxCapacity})
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        {error && <Typography color="error" variant="body2" mt={2}>{error}</Typography>}
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={() => { onClose(); setSectionId(""); setError(""); }} variant="outlined" color="inherit">Cancel</Button>
        <Button onClick={handleSubmit} variant="contained" disabled={loading}
          sx={{ background: "linear-gradient(90deg, #4A7BA8, #244C77)" }}>
          {loading ? "Assigning..." : "Assign"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AssignSectionDialog;
